// Configuration for toaster behavior across different API endpoints
export interface ToasterConfig {
  suppress: boolean;
  reason: string;
  customMessage?: string;
}

export const TOASTER_CONFIG: Record<string, ToasterConfig> = {
  getconveniencefee: {
    suppress: true,
    reason: 'Handled inline in payment form',
  },
  downloadDocument: {
    suppress: true,
    reason: 'Both download surfaces toast their own failure',
  },
};

// Function to determine if toaster should be suppressed for a given URL
export const shouldSuppressToaster = (url: string): boolean => {
  if (!url) return false;

  return Object.entries(TOASTER_CONFIG).some(([pattern, config]) => {
    if (url.includes(pattern)) {
      return config.suppress;
    }
    return false;
  });
};

// Function to get custom error message for an endpoint (if configured)
export const getCustomErrorMessage = (url: string): string | null => {
  if (!url) return null;

  const config = Object.entries(TOASTER_CONFIG).find(([pattern]) =>
    url.includes(pattern)
  );

  return config?.[1]?.customMessage || null;
};
